const ASSET_BASE =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_proof-landing-1/artifacts";

export const SHOTS = {
  ledger: `${ASSET_BASE}/cq4k2y88_IMG_0961.webp`,
  commitment: `${ASSET_BASE}/rijcnji6_IMG_0962.webp`,
  feed: `${ASSET_BASE}/yabh6nze_IMG_0964.webp`,
  declare: `${ASSET_BASE}/ijg6qs2h_IMG_0965.webp`,
  record: `${ASSET_BASE}/6pdcqxa9_IMG_0966.webp`,
  read: `${ASSET_BASE}/ehw42mgn_IMG_1283%202.webp`,
  call: `${ASSET_BASE}/f5wsvzx6_proof_call_photo.webp`,
  run: `${ASSET_BASE}/s4bobgye_IMG_1279%202.webp`,
  meetings: `${ASSET_BASE}/8qgio7st_proof_meetings_photo.webp`,
  gym: `${ASSET_BASE}/cg0gc4fb_IMG_1267%202.webp`,
  cook: `${ASSET_BASE}/7h6qj93p_IMG_1278%202.webp`,
};

export const SUPPORTING = {
  runner: `${ASSET_BASE}/uo0ppeij_pexels-rndiid-19783892.webp`,
  partner: `${ASSET_BASE}/kua4s042_pexels-artempodrez-8512178.webp`,
};
